export const promotions = {
  /**
   * Toggle the seasonal Black Friday promo UI.
   * Set NEXT_PUBLIC_BLACK_FRIDAY_PROMO="true" to re-enable.
   */
  blackFridayEnabled:
    typeof process.env.NEXT_PUBLIC_BLACK_FRIDAY_PROMO === "string"
      ? process.env.NEXT_PUBLIC_BLACK_FRIDAY_PROMO === "true"
      : false,
} as const;

